import type { RootState } from "~/store";
import type { GeneratePoSourceRow } from "~produce/purchasing/orders/create/helpers/generatePoPrefill";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import tenantChanged from "~/store/tenantChanged";

interface GeneratePoRequestState {
	rowsByRequestId: Record<string, GeneratePoSourceRow[]>;
}

const initialState: GeneratePoRequestState = { rowsByRequestId: {} };

const generatePoRequestSlice = createSlice({
	extraReducers: (builder) => {
		builder.addCase(tenantChanged, () => initialState);
	},
	initialState,
	name: "generatePoRequest",
	reducers: {
		clearGeneratePoRequest: (state, action: PayloadAction<string>) => {
			delete state.rowsByRequestId[action.payload];
		},
		stashGeneratePoRequest: (state, action: PayloadAction<{ requestId: string; rows: GeneratePoSourceRow[] }>) => {
			state.rowsByRequestId[action.payload.requestId] = action.payload.rows;
		}
	}
});

export const { clearGeneratePoRequest, stashGeneratePoRequest } = generatePoRequestSlice.actions;

export const selectGeneratePoRequestRows = (
	state: Pick<RootState, "generatePoRequest">,
	requestId: string | null
): GeneratePoSourceRow[] | undefined => (requestId ? state.generatePoRequest.rowsByRequestId[requestId] : undefined);

export default generatePoRequestSlice.reducer;
